import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import * as moment from "moment";
import { ModalViewreseauDeSoinDetailComponent } from "src/app/shared/components/modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component";


@Component({
  selector: 'app-modal-add-garant',
  templateUrl: './modal-add-garant.component.html',
  styleUrls: ['./modal-add-garant.component.scss']
})
export class ModalAddGarantComponent implements OnInit {

  listItems: Array<any> = [];
  items: Array<any> = [];
  itemToSave: any = {};
  indiceTab=0
  filiale_id:any
  uniteFonctionnelleSelected: any = {};
  modalRef: BsModalRef;
  isDetailMode=false
  user: any = {};
  itemToSearch: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  itemsListeModeGestAvenant:any=[{value:'MANUEL',libelle:'MANUEL'},{value:'AUTOMATIQUE',libelle:'AUTOMATIQUE'}]
  itemsPeriodiciteAvenant:any=[{value:'JOUR',libelle:'JOUR'},{value:'MOIS',libelle:'MOIS'},{value:'TRIMESTRE',libelle:'TRIMESTRE'},{value:'SEMESTRE',libelle:'SEMESTRE'},{value:'ANNEE',libelle:'ANNEE'},{value:'EXERCICE',libelle:'EXERCICE'}]
  itemsListeModeGestAccessoire:any=[{value:'GRILLE',libelle:'GRILLE'},{value:'PARTAGE',libelle:'PARTAGE'}]

  totalItems: number;
  show_password_field = true
  busyGet: Subscription;
  busySave: Subscription;
  loading: boolean = false;
  endPoint: string = "garant";
  title:string='garant'
  createMessage = ''
  editMessage =''
  deleteMessage =''
  itemsParentFonctionnalites=[]
  itemsRemboursement: any[] = []

  gender='M'
  itemsRole: any;
  itemsSpecialites: any;
  itemsCivilite:any=[]
  itemsGenre:any=[]
  itemsFiliale:any=[]
  itemsSourceFondCaution:any=[{code:'PROVISION-SINISTRE',libelle:'Provision sinistre'},{code:'FORFAIT',libelle:'Forfait'}]
  itemsSourceFondSinistre:any=[{code:'PROVISION-SINISTRE',libelle:'Provision sinistre'},{code:'SINISTRE-REEL',libelle:'Sinistre réel'}]
  itemsSourceFondHonoraire:any=[
    {code:'PROVISION-SINISTRE',libelle:'Provision sinistre'},
    {code:'SINISTRE-REEL',libelle:'Sinistre réel'},
    {code:'FORFAIT',libelle:'Forfait'},
    {code:'PRIME',libelle:'Prime'},
  ]
  periodicite:any=[
    {code:'MOIS',libelle:'Mois'},
    {code:'TRIMESTRE',libelle:'TRIMESTRE'},
    {code:'SEMESTRE',libelle:'SEMESTRE'},
    {code:'ANNEE',libelle:'ANNEE'},
  ]
  assietteDeFond:any=[
    {code:'GARANT',libelle:'Garant'},
    {code:'FAMILLE',libelle:'Famille'},
    {code:'BENEFICIAIRE',libelle:'Bénéficiaire'},
    {code:'AUCUNE',libelle:'Aucune'},
  ]

  searchKey:any
  dateNais: any;
  bsValue: Date;
  imageName: string;
  imageDisplay: any;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  };
  selectedUniteFoncId: any;
  selectedSpecialiteId: any;
  listSelectedUniteFonctionnelle = [];
  isAutoPassword=false
  maxDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth() - 1,
    new Date().getDay()
  );
  minDate = new Date();
  itemsFucntParent: any[];
  itemsTypeGarant: any;
  itemsTypeRemboursement: any;
  itemsCourtier: any[];
  itemsCommercial: any;
  itemsSouscripteur: any;
  itemsCategoriePolice: any[];
  currentData:any
  itemsModeTarification: any;
  itemsReseauDeSoin: any;
  itemsGarant: any;
  itemsAgence: any[];
  itemsStatutPolice: any;
  itemsModeReconduction: any;
  itemsModeFractionnement: any[];
  itemsTarif: any[];
  itemsModeReglement: any;
  itemsStatutGarant: any;
  itemsModeProrata: any;
  systemGlobal: any;
  mode_gestion_avenant: any;
  itemsTypeTarif: any;
  is_tpg: boolean=false;
  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService
  ) {
        // this.user = this.authService.currentUserValue;
        this.user = this.authService.getCurrentUser()
        // console.info('user-->: ',this.user)
        this.filiale_id = this.user.filiale_id
        let text1 = this.gender=='M'?'un':'une'
        this.createMessage = 'Vous êtes sur le point de créer '+text1+' '+this.title
        this.editMessage = 'Vous êtes sur le point de modifier '+text1+' '+this.title

        this.systemGlobal = JSON.parse(localStorage.getItem("globalSystem"));
        // console.log('systemGlobal: ',JSON.stringify(this.systemGlobal))
        if(this.systemGlobal && this.systemGlobal.length){
          this.itemToSave.mode_gest_avenant = this.systemGlobal.find(
            (sg: any) => sg.codification == "mode_gest_avenant"
          ).valeur;
  
          this.itemToSave.periodicite_avenant = this.systemGlobal.find(
            (sg: any) => sg.codification == "periodicite_avenant"
          ).valeur;
        }
        
    setTimeout(() => {
      console.log('here');
      this.itemToSave.date_effet = new Date()
      this.itemToSave.date_echeance = new Date((new Date()).getFullYear(), 11, 31, 23, 59, 59, 999);
      if (this.currentData) {
        console.log('currentData: ',this.currentData)
        this.isDetailMode = this.currentData.isDetailMode
        this.itemToSave = Object.assign({}, this.currentData);
        this.itemToSave.date_effet = this.itemToSave.date_effet?moment(this.itemToSave.date_effet).toDate():new Date()
        this.itemToSave.date_echeance = this.itemToSave.date_echeance?moment(this.itemToSave.date_echeance).toDate():new Date((new Date()).getFullYear(), 11, 31, 23, 59, 59, 999)
        this.onSelectTypeRemboursement()
        // this.itemToSave.date_effet = this.itemToSave.date_effet?moment(this.itemToSave.date_effet).format('MMMM Do YYYY, h:mm:ss a'):new Date()
        // this.itemToSave.date_echeance = this.itemToSave.date_echeance?moment(this.itemToSave.date_echeance).format('MMMM Do YYYY, h:mm:ss a'):new Date((new Date()).getFullYear(), 11, 31, 23, 59, 59, 999)
      }
    }, 50);

  }
  confirmSaveItem(item) {
    console.info('item: ', item)

    console.info(" itemToSave ", this.itemToSave);
    console.info(" item ", item);


    if(!item.id && !item.code)
      item.code = this.generateUniqueString()

    

    
    // item.specialiteId = this.selectedSpecialite.id

     if (item.source_fond_sinistre =='SINISTRE-REEL' && item.assiete_fond_sinistre!='AUCUNE') {
      this.utilities.showNotification(
        "snackbar-danger",
        "Facture honoraire: sinistre réel ==> aucune assiète !",
        "bottom",
        "center"
      );
      return;
    }
     if (item.source_fond_honoraire =='SINISTRE-REEL' && item.assiete_fond_honoraire!='AUCUNE') {
      this.utilities.showNotification(
        "snackbar-danger",
        "Facture honoraire: sinistre réel ==> aucune assiète !",
        "bottom",
        "center"
      );
      return;
    }

    if (!item || !item.libelle) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner libellé !",
        "bottom",
        "center"
      );
      return;
    }
    if (!item || !item.type_garant_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner type !",
        "bottom",
        "center"
      );
      return;
    }
    if (!item || !item.mode_gest_accessoire) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner mode gestion accéssoires !",
        "bottom",
        "center"
      );
      return;
    }

    



    // if (!item || !item.type_remboursement_id) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner type remboursement!",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }

    if (item.is_prorata_prime && !item.mode_prorata_id ) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner le mode de prorata!",
        "bottom",
        "center"
      );
      return;
    }

if (item.mode_gest_accessoire === 'PARTAGE') {
  const total = 
    (item.taux_partage_accessoire ?? 0) +
    (item.taux_partage_accessoire_garant ?? 0) +
    // (item.taux_partage_accessoire_courtier ?? 0) +
    // (item.taux_partage_accessoire_apporteur ?? 0) +
    (item.taux_partage_accessoire_intermediaire ?? 0);

  console.log('total:', total);

  if (total !== 100) {
    this.utilities.showNotification(
      'snackbar-danger',
      'La somme des taux de partage doit être égale à 100 !',
      'bottom',
      'center'
    );
    return;
  }
}





    

    item.type_id = item.type
    if(item.id){
      delete item.type;
    }

    let objToSave = Object.assign({}, item);
    

    Swal.fire({
      title: this.capitalize(this.title),
      text: objToSave?.id
        ? this.editMessage
        : this.createMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0665aa",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then((result) => {
      if (result.value) {
        ;
        this.saveItem(objToSave);
      }
    });
  }

  selectedChangeValue(event : any)
{
  console.log("le event selectedChangeValue",event);
  
  if(!event) this.indiceTab = 0;

  this.indiceTab = event;
} 

  saveItem(item) {
    console.info("item to save", item);

    this.loading = true;

    let itemAEnregistrer = Object.assign({}, item);
    let reduce = [];
    itemAEnregistrer.filiale_id = this.filiale_id || this.user.filiale_id
    if (this.currentItemImage && Object.keys(this.currentItemImage).length) {
      itemAEnregistrer.file_data = this.currentItemImage;
    } else {
      delete itemAEnregistrer.file_data;
    }
    var request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      datas: [itemAEnregistrer],
    };

    this.busySave = this.restClient
      .post(
        this.endPoint + "" + (itemAEnregistrer.id ? "/update" : "/create"),
        request
      )
      .subscribe(
        (res) => {
          console.info("resul", res);
          this.loading = false;

          if (!res["hasError"]) {
              this.utilities.showNotification(
                "snackbar-success",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );

              this.bsModalRef.hide();
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center"
          );
          this.loading = false;
        }
      );
  }
  addDocument(event) {
    console.log("addDocument: ", event);
    // this.datasFile = event;
  }

  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => { }
      );
  }

  getItemsTypeRemboursement() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("typeRemboursement/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsTypeRemboursement = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );

            if(this.itemToSave.id){
              this.onSelectTypeRemboursement()
            }
          } else {
            this.itemsTypeRemboursement = [];
          }
        },
        (err) => {
          this.itemsTypeRemboursement = [];

        }
      );
  }

  getItemsRemboursement() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.restClient
      .post("typeAssureRemboursement/getByCriteria", request)
      .subscribe(
        (res) => {
          this.itemsRemboursement = res && res["items"] ? _.orderBy(res["items"], ["libelle"], ["asc"]) : [];
        },
        (err) => { this.itemsRemboursement = []; }
      );
  }

  getItemsTypeGarant() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("typeGarant/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsTypeGarant = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsTypeGarant = [];
          }
        },
        (err) => { 
          this.itemsTypeGarant = [];

        }
      );
  }
  getItemsTarif() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        type_tarif_id: this.itemsTypeTarif.find(
          (itt) => itt.codification == "TAR-GAR"
        ).id,
      },
    };

    this.busyGet = this.restClient
      .post("tarif/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsTarif = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsTarif = [];
          }
        },
        (err) => { 
          this.itemsTarif = [];

        }
      );
  }

  getItemsTypeTarif() {
      let request = {
        user_id: this.user.id,
        filiale_id: this.user.filiale_id,
        index: 0,
        size: 1000,
        data: {
          // type_tarif_id:this.itemto
        },
      };
  
      this.busyGet = this.restClient
        .post("typeTarif/getByCriteria", request)
        .subscribe(
          (res) => {
            if (res && res["items"]) {
              this.itemsTypeTarif = _.orderBy(res["items"], ["libelle"], ["asc"]);
            } else {
              this.itemsTypeTarif = [];
            }
            this.getItemsTarif();
          },
          (err) => {
            this.itemsTypeTarif = [];
          }
        );
    }
  getItemsCourtier() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("courtier/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsCourtier = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsCourtier = [];
          }
        },
        (err) => { 
          this.itemsCourtier = [];

        }
      );
  }

  getItemsCommercial() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("commercial/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsCommercial = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsCommercial = [];
          }
        },
        (err) => { 
          this.itemsCommercial = [];

        }
      );
  }

  getItemsModeTarification() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("modeTarification/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsModeTarification = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsModeTarification = [];
          }
        },
        (err) => { 
          this.itemsModeTarification = [];

        }
      );
  }
  getItemsModeReconduction() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("modeReconduction/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsModeReconduction = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsModeReconduction = [];
          }
        },
        (err) => { 
          this.itemsModeReconduction = [];

        }
      );
  }
  getItemsModeFractionnement() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("modeFractionnement/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsModeFractionnement = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsModeFractionnement = [];
          }
        },
        (err) => { 
          this.itemsModeFractionnement = [];

        }
      );
  }
  getItemsModeReglement() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("modeReglement/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsModeReglement = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsModeReglement = [];
          }
        },
        (err) => { 
          this.itemsModeReglement = [];

        }
      );
  }
  getItemsSouscripteur() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("souscripteur/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsSouscripteur = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsSouscripteur = [];
          }
        },
        (err) => { 
          this.itemsSouscripteur = [];

        }
      );
  }
getItemsCategoriePolice() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("categoriePolice/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsCategoriePolice = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsCategoriePolice = [];
          }
        },
        (err) => { 
          this.itemsCategoriePolice = [];

        }
      );
}

getItemsReseauDeSoin() {
  let request = {
    user_id: this.user.id,
    filiale_id:this.user.filiale_id,
    index: 0,
    size: 1000,
    data: {},
  };

  this.busyGet = this.restClient
    .post("reseauDeSoin/getByCriteria", request)
    .subscribe(
      (res) => {
        if (res && res["items"]) {
          this.itemsReseauDeSoin = _.orderBy(
            res["items"],
            ["libelle"],
            ["asc"]
          );
        } else {
          this.itemsReseauDeSoin = [];
        }
      },
      (err) => { 
        this.itemsReseauDeSoin = [];

      }
    );
}
getItemsGarant() {
  let request = {
    user_id: this.user.id,
    filiale_id:this.user.filiale_id,
    index: 0,
    size: 1000,
    data: {},
  };

  this.busyGet = this.restClient
    .post("garant/getByCriteria", request)
    .subscribe(
      (res) => {
        if (res && res["items"]) {
          this.itemsGarant = _.orderBy(
            res["items"],
            ["libelle"],
            ["asc"]
          );
        } else {
          this.itemsGarant = [];
        }
      },
      (err) => { 
        this.itemsGarant = [];

      }
    );
}
getItemsAgence() {
  let request = {
    user_id: this.user.id,
    filiale_id:this.user.filiale_id,
    index: 0,
    size: 1000,
    data: {},
  };

  this.busyGet = this.restClient
    .post("agence/getByCriteria", request)
    .subscribe(
      (res) => {
        if (res && res["items"]) {
          this.itemsAgence = _.orderBy(
            res["items"],
            ["libelle"],
            ["asc"]
          );
        } else {
          this.itemsAgence = [];
        }
      },
      (err) => { 
        this.itemsAgence = [];

      }
    );
}
getItemsStatutGarant() {
  let request = {
    user_id: this.user.id,
    filiale_id:this.user.filiale_id,
    index: 0,
    size: 1000,
    data: {},
  };

  this.busyGet = this.restClient
    .post("statutGarant/getByCriteria", request)
    .subscribe(
      (res) => {
        if (res && res["items"]) {
          this.itemsStatutGarant = _.orderBy(
            res["items"],
            ["libelle"],
            ["asc"]
          );
        } else {
          this.itemsStatutGarant = [];
        }
      },
      (err) => { 
        this.itemsStatutGarant = [];

      }
    );
}
getItemsModeProrata() {
  let request = {
    user_id: this.user.id,
    filiale_id:this.user.filiale_id,
    index: 0,
    size: 1000,
    data: {},
  };

  this.busyGet = this.restClient
    .post("modeProrata/getByCriteria", request)
    .subscribe(
      (res) => {
        if (res && res["items"]) {
          this.itemsModeProrata = _.orderBy(
            res["items"],
            ["libelle"],
            ["asc"]
          );
        } else {
          this.itemsModeProrata = [];
        }
      },
      (err) => { 
        this.itemsModeProrata = [];

      }
    );
}

  // onSelectDate(event) {
  //   if (event) {
  //     (this.dateNais = moment(event).format("DD/MM/YYYY")),
  //       console.info("dateNais", this.dateNais);
  //   }
  // }

isValidEmail(email) {
    // Regular expression for validating email addresses
    var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}

generateUniqueString() {
  // Get current timestamp in milliseconds
  var timestamp = new Date().getTime();

  // Generate a random number
  var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

  // Concatenate timestamp and random number
  var uniqueString = timestamp.toString() + randomNumber.toString();

  return uniqueString;
}



capitalize(str) {
  return str.replace(/^\w/, (c) => c.toUpperCase());
}

onSelectTypeRemboursement(){
  let selected_type_remboursement = this.itemsTypeRemboursement && this.itemsTypeRemboursement.length?this.itemsTypeRemboursement.find(itr=>itr.id == this.itemToSave.type_remboursement_id):{}
  this.is_tpg = selected_type_remboursement && selected_type_remboursement.codification == 'TPG'
  if(!this.itemToSave.taux_tpg){
    this.itemToSave.taux_tpg = 100
  }
  if(!this.itemToSave.plafond_tpg){
    this.itemToSave.plafond_tpg = 0
  }
  if(!this.itemToSave.majoration_tpg){
    this.itemToSave.majoration_tpg = 0
  }
}

load_filiale_data(){
  // this.getItems();
  this.getItemsTypeRemboursement()
}

openModalPrestataireReseau() {
  if(!this.itemToSave.reseau_de_soin_id)
    return
  let modal: any;
  modal = ModalViewreseauDeSoinDetailComponent;
  this.modalRef = this.modalService.show(modal, {
    id: 5458545,
    class: "modal-width-75",
    ignoreBackdropClick: true,
    // data:boulangerie
  });
  let reseau_id = this.itemToSave.reseau_de_soin_id
  let reseau_de_soin_libelle = this.itemsReseauDeSoin.filter(ird=>ird.id == reseau_id)[0].libelle
  let data = {reseau_de_soin_id:reseau_id,reseau_de_soin_libelle:reseau_de_soin_libelle}
  if (data) this.modalRef.content.currentData = data;
  this.modalRef.onHide.subscribe((res) => {
  });


}

uploadFile(event: any) {
  console.log('event: ',event)
  const reader = new FileReader();
  if (event.target.files && event.target.files.length) {
    const file = event.target.files[0];
    const fileName = file.name.split(".")[0];
    const Tabextension = file.name.split(".");
    const extension = Tabextension[Tabextension.length - 1];

    console.info("fileName", fileName);
    console.info("extension", extension);
    this.imageName = fileName + "." + extension;
    reader.onload = (readerEvent) => {
      const data = (readerEvent.target as any).result;
      this.imageDisplay = data;
      const fileBase64 = data.split(",")[1];
      this.currentItemImage = {
        fileBase64: fileBase64,
        fileName: fileName,
        extension: extension,
        typeDocument: "custom type",
      };
      // console.log('currentItemImage: ',this.currentItemImage)
    };
  }

  reader.readAsDataURL(event.target.files[0]);
}

handleImageError(item){
  item.image_url = 'assets/images/custom/user-ano.jpeg'
}

onChangeSourceFondCaution(){}
onChangePeriodiciteFondSinistre(){}
onChangePeriodiciteFondHonoraire(){}
onChangePeriodiciteDeficit(){}
onChangeSourceFondHonoraire(){}
onChangeSourceFondSinistre(){
  console.log("itemToSave.source_fond_sinistre: ",this.itemToSave.source_fond_sinistre)
  if(this.itemToSave.source_fond_sinistre=='SINISTRE-REEL'){
    this.itemToSave.assiete_fond_sinistre='AUCUNE'
  }
}


onChangeAssieteSinistre(){}
onChangeAssieteHonoraire(){}
onChangeAssieteCaution(){}

  ngOnInit() {

    this.getItemsFiliale();
    this.getItemsTypeRemboursement()
    this.getItemsRemboursement()
    this.getItemsCourtier()
    this.getItemsCommercial()
    this.getItemsSouscripteur()
    this.getItemsCategoriePolice()
    this.getItemsModeTarification()
    this.getItemsModeReconduction()
    this.getItemsReseauDeSoin()
    this.getItemsGarant()
    this.getItemsAgence()
    this.getItemsModeProrata()
    this.getItemsStatutGarant()
    this.getItemsModeFractionnement()
    // this.getItemsTarif()
    this.getItemsTypeTarif()
    this.getItemsModeReglement()
    this.getItemsTypeGarant()
    this.getItemsStatutGarant()
  }

}
